import {handleApiResponse, parseDatesToMoment, postJson} from 'src/portal/common/utils';

/**
 * Creates a "confirm and POST" action handler for buttons with an "are you sure?" pattern.
 * Used by deactivate, terminate, reset MFA, etc.
 *
 * @param failureMessage - Message to log on failure
 */
export function makeConfirmAction(failureMessage: string): (event: MouseEvent) => void {
	return (event: MouseEvent) => {
		event.stopPropagation();

		const button = event.currentTarget as HTMLElement;
		const url: string = button.dataset.url || '';
		const container: HTMLElement = button.parentElement || document.createElement('div');

		const buttonOriginalDisplay = button.style.display;
		button.style.display = 'none';

		const areYouSureElements = Array.from(container.getElementsByClassName('areyousure')) as HTMLElement[];
		areYouSureElements.forEach((el: HTMLElement) => {
			el.style.display = 'inline-block';
		});

		const yesButton: any = container.getElementsByClassName('areyousure-yes')[0];
		yesButton.onclick = () => {
			fetch(url, postJson())
				.then(handleApiResponse)
				.then((response) => response.json())
				.then((json) => parseDatesToMoment(json))
				.then((json) => {
					if (json.isSuccessful) {
						window.location.reload();
					} else {
						console.log(failureMessage, json);
					}
				})
				.catch((error) => {
					console.error(error);
				});
		};

		const noButton: any = container.getElementsByClassName('areyousure-no')[0];
		noButton.onclick = () => {
			button.style.display = buttonOriginalDisplay;
			areYouSureElements.forEach((el: HTMLElement) => {
				el.style.display = 'none';
			});
		};
	};
}
